import { CONFIG_MANIFEST_URL } from "@/config";

import { GetConfigManifestResponse } from "./types";

const apiHubToken = import.meta.env.VITE_JSON_RPC_TOKEN;

export const getConfigManifest =
    async (): Promise<GetConfigManifestResponse> => {
        const response = await fetch(CONFIG_MANIFEST_URL, {
            method: "GET",
            headers: {
                "Api-Hub-token": apiHubToken,
            },
        });

        if (!response.ok) {
            throw new Error(
                `Failed to fetch config manifest: ${response.status}`,
            );
        }

        const result = (await response.json()) as GetConfigManifestResponse;

        return result;
    };
